import React, { PureComponent } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { get as _get } from 'lodash';

export const AvailRoleToken = ({ role }) => {
  let abb, color;
  if (role === 'Driver') {
    abb = 'DR';
    color = '#000000';
  } else if (role === 'Team Leader') {
    abb = 'TL';
    color = '#DC873F';
  } else if (role === 'Day 1') {
    abb = 'D1';
    color = '#cc63b1';
  } else if (role === 'Day 2') {
    abb = 'D2';
    color = '#a5acf9';
  } else if (role === 'Day 3') {
    abb = 'D3';
    color = '#4e5beb';
  } else if (role === 'Canvasser') {
    abb = 'CORE';
    color = '#66dfa6';
  }

  if (!abb) return null;

  return (
    <span className={'availRoleToken'} style={{ color, borderColor: color }}>
      {abb}
    </span>
  );
};

class DraggableShiftCanvasser extends PureComponent {
  constructor(props) {
    super(props);
  }

  _renderCanvasser(provided, snapshot) {
    return (
      <div
        className={`schedule-canvasser-card`}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <div
          className="available-route"
          style={{ borderLeftColor: this.props.color, color: this.props.color }}
          id={this.props.id}
        >
          <div className="obj-title small-font">
            {this.props.canvasser.firstname} {this.props.canvasser.lastname}{' '}
            <span className={'slashline'}>{this.props.canvasser.metrics}</span>{' '}
          </div>
          <div className="obj-data small-font">
            {_get(this.props, 'canvasser.is_training', false) && (
              <span className={'assignedToken danger'}>TRAINING USER</span>
            )}
          </div>
          <div className="obj-data small-font">
            {this.props.assigned && <span className={'assignedToken'}>Assigned</span>}
            {_get(this.props, 'canvasser.abilities', []).map((d) => (
              <AvailRoleToken role={(d || {}).name} key={d.id} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  // TODO: add classNames conditionally based off of which scheduling column the siteroute is in
  // TODO: need different class for the remove icon
  render() {
    let draggableId = this.props.draggableId;
    return (
      <Draggable
        draggableId={draggableId}
        index={this.props.index}
        key={this.props.draggableId + this.props.index}
      >
        {(provided, snapshot) => <>{this._renderCanvasser(provided, snapshot)}</>}
      </Draggable>
    );
  }
}

export default DraggableShiftCanvasser;
